"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountFeatures = void 0;
var enums_1 = require("./enums");
var AccountFeaturesProperties = ['private_meetings', 'public_meetings', 'meeting_peer_to_peer', 'meeting_voximplant', 'meeting_webinar', 'meeting_webstream', 'meetings_max_participants', 'meetings_max_duration_minutes', 'public_meeting_deposit_usd', 'payment_processing_fee_percent', 'payout_processing_fee_percent', 'referral_student_platform_fee_percent', 'repeated_student_platform_fee_percent', 'other_student_platform_fee_percent', 'platform_fee_min_usd', 'overridePlanPriceUSD', 'overrideCreditsPriceUSD', 'overrideUserServicePriceUSD', 'overrideMeetingPriceUSD', 'overrideCollectionPriceUSD'];
var AccountFeatures = /** @class */function () {
  function AccountFeatures(values) {
    if (values === void 0) {
      values = {};
    }
    // public meetings_billing_credits = AccountFeatureStateEnum.disabled;
    // public meetings_billing_usd = AccountFeatureStateEnum.disabled;
    /** приватные митинги */
    this.meetings_private = enums_1.AccountFeatureStateEnum.enabled;
    /** публичные митинги */
    this.meetings_public = enums_1.AccountFeatureStateEnum.promoted;
    /** митинг peer-to-peer */
    this.meetings_peer_to_peer = enums_1.AccountFeatureStateEnum.enabled;
    /** митинг - веб-конференция */
    this.meetings_webconference = enums_1.AccountFeatureStateEnum.promoted;
    this.meetings_webinar = enums_1.AccountFeatureStateEnum.promoted;
    this.meetings_webstream = enums_1.AccountFeatureStateEnum.promoted;
    /** максимальное количество участников */
    this.meetings_max_participants = 2;
    /** максимальная продолжительность в минутах */
    this.meetings_max_duration_minutes = 10;
    /** Гарантийный депозит для создания публичного класса */
    this.public_meeting_deposit_usd = 20;
    /** Сбор за процессинг платежа */
    this.payment_processing_fee_percent = 4.72;
    /** Сбор за процессинг выплаты */
    this.payout_processing_fee_percent = 4.72;
    /** Сбор платформы за приглашённого на урок НОВОГО ученика */
    this.referral_student_platform_fee_percent = 20;
    /** Сбор платформы за приглашённого на урок СВОЕГО ученика */
    this.repeated_student_platform_fee_percent = 20;
    /** Сбор платформы за ДРУГОГО ученика */
    this.other_student_platform_fee_percent = 40;
    /** Минимальный сбор платформы за ЛЮБОГО ученика */
    this.platform_fee_min_usd = 1;
    var properties = AccountFeaturesProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
  }
  return AccountFeatures;
}();
exports.AccountFeatures = AccountFeatures;
